import {
  PRODUCT_BATCH_SIZE,
  ProBuyerPrice,
  fetchProductProBuyerPrices,
} from "@/features/pro-buyer-price/data/pro-buyer-price-client";

type Waiter = (price: ProBuyerPrice | null) => void;

/**
 * WHO-5743. A search page renders 24 cards and each asks for its own Pro
 * Buyer price. Requests made in the same tick are collected and sent as one
 * aliased operation per `PRODUCT_BATCH_SIZE` ids, per viewer token.
 */
const pending = new Map<string, Map<string, Waiter[]>>();
let scheduled = false;

const flush = () => {
  scheduled = false;
  const batches = Array.from(pending.entries());
  pending.clear();

  for (const [token, waitersById] of batches) {
    const ids = Array.from(waitersById.keys());

    for (let start = 0; start < ids.length; start += PRODUCT_BATCH_SIZE) {
      const chunk = ids.slice(start, start + PRODUCT_BATCH_SIZE);

      void fetchProductProBuyerPrices(token, chunk).then(prices => {
        for (const id of chunk) {
          const price = prices.get(id) ?? null;
          waitersById.get(id)?.forEach(resolve => resolve(price));
        }
      });
    }
  }
};

export const loadProductProBuyerPrice = (
  token: string,
  productId: string
): Promise<ProBuyerPrice | null> =>
  new Promise(resolve => {
    const waitersById = pending.get(token) ?? new Map<string, Waiter[]>();
    waitersById.set(productId, [
      ...(waitersById.get(productId) ?? []),
      resolve,
    ]);
    pending.set(token, waitersById);

    if (!scheduled) {
      scheduled = true;
      setTimeout(flush, 0);
    }
  });
